/**
 * Converts stored HTML (as saved by a rich-text editor like Quill, which
 * wraps even a single line in `<p>...</p>`) back into clean plain text -
 * for fields that display as a plain `<textarea>` today but may still hold
 * legacy values from when the same field was a rich-text editor. Without
 * this, a stored `<p>bhargav</p>` renders as that literal string instead of
 * "bhargav" (SCRUM-156).
 *
 * A no-op for values that are already plain text (the common case for
 * anything saved since the field switched to `<textarea>`).
 */
export const htmlToPlainText = (value) => {
  if (!value || typeof value !== "string") return value || "";
  if (!/<[a-z][\s\S]*>/i.test(value)) return value;

  const withBreaks = value
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|li|h[1-6])>/gi, "\n");

  const container = document.createElement("div");
  container.innerHTML = withBreaks;
  const text = container.textContent || container.innerText || "";

  return text
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};
